import { handleResponse } from "utils/utils";
import { authService } from "./authService";

export function getMessagingToken() {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}auth/zendesk-messaging-token`,
		requestOptions
	).then((response) => handleResponse(response, { ignore401: true }));
}
